import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { View, Text, Platform, Dimensions, StyleSheet, TouchableOpacity } from 'react-native';
import Modal from 'react-native-modal';
import { Picker } from '@react-native-picker/picker';
import dayjs from 'dayjs';

import Colors from '../../constants/Colors';
import timeUtils from '../../utils/timeUtils';

function BirthdaySelectModal(props) {
  const { translation, date, locale, onSelect, onCancel } = props;
  const serviceDate = timeUtils.getServiceDateFromUnixTimestamp(date);
  const [year, setYear] = useState(serviceDate.split('-')[0]);
  const [month, setMonth] = useState(serviceDate.split('-')[1]);
  const [day, setDay] = useState(serviceDate.split('-')[2]);

  const labels = {
    birth_date: Platform.OS === 'web' ? translation.dob_required : translation.app_personal_edittext_dob,
    cancel: translation.app_button_cancel,
    ok: translation.app_button_ok,
  };

  const years = [];
  const months = [];
  const days = [];
  const endYear = parseInt(timeUtils.getServiceDateFromDate(new Date()).split('-')[0], 10) - 12;
  const thirtheenYears = dayjs().subtract(13, 'year').unix();
  for (let i = 1900; i < endYear; i++) {
    years.push(<Picker.Item key={`Year-${i}`} label={`${i}`} value={`${i}`} />);
  }
  for (let j = 1; j < 13; j++) {
    const monthLabel = timeUtils.getMonthLabel(j - 1, locale);
    months.push(<Picker.Item key={`Month-${j}`} label={monthLabel} value={j.toString().padStart(2, '0')} />);
  }
  const daysInMonth = timeUtils.getDaysInMonth(year, month);
  for (let k = 1; k <= daysInMonth; k++) {
    days.push(<Picker.Item key={`Day-${k}`} label={`${k}`} value={k.toString().padStart(2, '0')} />);
  }

  const deviceWidth = Dimensions.get('window').width;
  const deviceHeight = Dimensions.get('window').height + 400;

  const selectBirthdate = () => {
    const timestamp = new Date(`${year}-${month}-${day}`).getTime() / 1000;
    if (timestamp < thirtheenYears) {
      onSelect(timestamp);
    }
  };

  return (
    <Modal
      isVisible
      deviceHeight={deviceHeight}
      deviceWidth={deviceWidth}
      style={styles.modal}
      testID="birth-date-selector"
    >
      <View style={styles.contentContainer}>
        <View style={styles.header}>
          <Text style={styles.headerText}>{labels.birth_date}</Text>
        </View>

        <View style={styles.body}>
          <Picker
            selectedValue={`${month}`}
            style={[styles.dropdown, styles.dropdownMonth]}
            onValueChange={(itemValue) => setMonth(itemValue)}
            testID="month"
          >
            {months}
          </Picker>

          <Picker
            selectedValue={day}
            style={[styles.dropdown, styles.dropdownDay]}
            onValueChange={(itemValue) => setDay(itemValue)}
            testID="day"
          >
            {days}
          </Picker>

          <Picker
            selectedValue={year}
            style={[styles.dropdown, styles.dropdownYear]}
            onValueChange={(itemValue) => setYear(itemValue)}
            testID="year"
          >
            {years}
          </Picker>
        </View>

        <View style={styles.buttonRow}>
          <TouchableOpacity onPress={onCancel} testID="button-cancel">
            <Text style={styles.cancelText}>{labels.cancel}</Text>
          </TouchableOpacity>
          <TouchableOpacity onPress={selectBirthdate} style={styles.confirmButton} testID="submit-birth-date">
            <Text style={styles.buttonText}>{labels.ok}</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  contentContainer: {
    flex: 0,
    backgroundColor: Colors.white,
    justifyContent: 'center',
    alignItems: 'center',
    width: Platform.OS === 'web' ? 300 : 'auto',
    height: 300,
    marginHorizontal: Platform.OS === 'web' ? 'auto' : 20,
    marginVertical: Platform.OS === 'web' ? 'auto' : 150,
  },
  header: {
    height: 66,
    width: '100%',
    backgroundColor: Colors.mediumBlue,
    justifyContent: 'center',
    paddingLeft: 24,
  },
  headerText: {
    color: Colors.white,
    fontSize: 20,
  },
  body: {
    height: Platform.OS === 'web' ? 'auto' : 200,
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: Colors.white,
  },
  dropdown: {
    height: 50,
    borderColor: Colors.white,
  },
  dropdownDay: {
    width: 100,
  },
  dropdownMonth: {
    width: 110,
  },
  dropdownYear: {
    width: 120,
  },
  buttonRow: {
    height: 52,
    width: '100%',
    backgroundColor: Colors.lightGrayBackground,
    borderTopWidth: 1,
    borderTopColor: Colors.grayBorder,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingTop: 8,
    paddingRight: 8,
  },
  disabledButton: {
    padding: 10,
    backgroundColor: Colors.grayButton,
  },
  confirmButton: {
    padding: 10,
    marginBottom: 6,
    backgroundColor: Colors.primaryColor,
    borderRadius: 4,
  },
  cancelText: {
    marginTop: 10,
    marginRight: 20,
    textTransform: 'uppercase',
    fontWeight: '500',
  },
  buttonText: {
    color: Colors.white,
    textTransform: 'uppercase',
    fontWeight: '500',
  },
});

BirthdaySelectModal.propTypes = {
  translation: PropTypes.objectOf(PropTypes.any).isRequired,
  onSelect: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  date: PropTypes.number, // unix timestamp
  locale: PropTypes.string.isRequired,
};

export default BirthdaySelectModal;
